<template>
  <div id="ag-grid-lists">
    <div id="div-with-loading" class="vs-con-loading__container">
      <vs-tabs class="partner-lists-page custom-vs-tabs slot-border-top">
        <vs-tab label="New Requests">
          <div class="tab-text">
            <ResellerNewReqList></ResellerNewReqList>
          </div>
        </vs-tab>

        <vs-tab label="Edit Requests">
          <div class="tab-text">
            <ResellerEditReqList></ResellerEditReqList>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <ViewOrEditReseller></ViewOrEditReseller>
  </div>
</template>

<script>
import ResellerNewReqList from '@/components/ag-grid-tables/partners/ResellerNewReqList.vue';
import ResellerEditReqList from '@/components/ag-grid-tables/partners/ResellerEditReqList.vue';

import ViewOrEditReseller from '@/components/ag-grid-tables/partners/ViewOrEditReseller.vue';

export default {
  name: 'ViewResellerRequests',
  components: {
    ResellerNewReqList,
    ResellerEditReqList,
    ViewOrEditReseller
  }
}
</script>

<style>

</style>